import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatButtonModule } from '@angular/material/button';
import { CustomersComponent } from './customers/customers.component';
import { AdvantagesComponent } from './advantages/advantages.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { StartTransferComponent } from './start-transfer/start-transfer.component';
import { FooterComponent } from './footer/footer.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { RedirectDropdownComponent } from './redirect-dropdown/redirect-dropdown.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SelectLanguageDialogComponent } from './select-language-dialog/select-language-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BlockedContentDialogComponent } from './blocked-content-dialog/blocked-content-dialog.component';

const MODULES = [
  CommonModule,
  TranslateModule,
  MatIconModule,
  MatMenuModule,
  RouterModule,
  OverlayModule,
  MatButtonModule,
  MatSelectModule,
  FormsModule,
  MatProgressBarModule,
  MatDialogModule,
];

const COMPONENTS = [
  HeaderComponent,
  CustomersComponent,
  AdvantagesComponent,
  HowItWorksComponent,
  StartTransferComponent,
  FooterComponent,
  RedirectDropdownComponent,
  BlockedContentDialogComponent,
];

const DIRECTIVES = [];

@NgModule({
  imports: [
    ...MODULES,
  ],
  exports: [
    ...MODULES,
    ...COMPONENTS,
  ],
  declarations: [
    ...COMPONENTS,
    SelectLanguageDialogComponent,
  ],
})
export class SharedModule { }
